import React, { useState, useEffect, FC, useRef } from 'react';
import { StyleSheet, View, TextInput, KeyboardAvoidingView, Platform } from 'react-native';
import { Button, Text, IconButton } from 'react-native-paper';
import Colors from '../../resources/Colors';
import GlobalStyles from '../../resources/Styles';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { doLoginAction, validateLoginAction } from '../../controller/authController';
import Alerts from '../../components/Alerts';
 import { GoogleLogin } from '@react-oauth/google';
 import jwt_decode from 'jwt-decode'; // You might need to install this library


// // 🛑 AVISO: Las declaraciones de tipos son necesarias si usas TypeScript
// declare global {
//   interface Window {
//     google: any; 
//   }
// }

// const WEB_CLIENT_ID = '574407864279-bsr4d4ig72prrggro244ipj4h3nfj320'; // 🛑 REEMPLAZA ESTO

const LoginScreen: FC<IRoute> = ({ navigation }) => {
  const auth = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();

    const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const googleButtonRef = useRef(null);

  // useEffect(() => {
  //   if (auth.isLoggedIn) {
  //     navigation.navigate('Main');
  //   }
  //   if (window.google) {
  //           // 1. Inicializar Google Identity Services
  //           window.google.accounts.id.initialize({
  //               client_id: WEB_CLIENT_ID,
  //               scope: 'email',
  //               //response_type: 'code', // Indica que queremos el código de autorización
  //               callback: handleCredentialResponse, // Función que maneja la respuesta
    
  //   // **Importante:** Este URI DEBE ser tu endpoint en Flask y estar AUTORIZADO en Google Cloud
  //   redirect_uri: 'http://localhost:8080',
  //           });

  //           // 2. Renderizar el botón de Google (usando un div referenciado)
  //           // Esto solo funciona en la web
  //           window.google.accounts.id.renderButton(
  //               googleButtonRef.current, // El elemento DOM donde se insertará el botón
  //               { theme: 'outline', size: 'large', type: 'standard' } // Opciones de estilo
  //           );
  //       }
  // }, []);

  useEffect(() => {
    setTimeout(() => {
      //setAnimating(true);
      dispatch(validateLoginAction());
    }, 1000);
  }, []);

  const doLogin = () => {
    dispatch(doLoginAction(email, password));
  };

  const handleCredentialResponse = (response) => {
    console.log("respuesta del google", response)
        // response.credential contiene el ID Token (JWT)
        const idToken = response.credential;
        const emailS = response.email;
        
        if (idToken && emailS) {
            console.log('ID Token recibido:', idToken);
            dispatch(doLoginAction(emailS, idToken));
            // 🛑 Enviar el idToken a tu backend para validación
            // dispatch(loginWithGoogleAction(idToken)); 
        }
    };

    const handleSuccess = (credentialResponse) => {
      console.log("crendeicals", credentialResponse)
        //const decoded = jwt_decode(credentialResponse.credential);
        console.log(decoded);
        // Process user data, e.g., send to your backend for further authentication
      };

      const handleError = () => {
        console.log('Login Failed');
      };


  return (
    <KeyboardAvoidingView style={{ flex: 1, backgroundColor: "#fff" }} behavior='padding'>
      <View
        style={[style.container, Platform.OS === "web" ? style.containerWeb : null, { alignItems: 'center', paddingHorizontal: 45 }]}>
        <View style={{ flex: 1 }} />
        <Text variant={'titleLarge'} style={{ color: Colors.primary, fontSize: 28 }}>
          Welcome Back !
        </Text>
        <Text style={[style.label, { marginTop: 8 }]}>
          Sign in to continue
        </Text>
        <View style={{ width: '100%', marginTop: 30 }}>
          <Text style={[style.label, { marginTop: 10 }]}>Username</Text>
          <TextInput
            style={style.inputText}
            defaultValue={email}
            placeholder={'Enter username'}
            placeholderTextColor={Colors.inputTextPlaceHolderColor}
            textContentType={'username'}
            autoCapitalize={'none'}
            autoComplete={'email'}
            inputMode={'email'}
            onChangeText={value => setEmail(value)}
          />
          <View style={[style.horizontalContent, Platform.OS === "web" ? style.viewWeb : null]}>
            <Text style={[style.label, Platform.OS === "web" ? style.textWeb : null]}>Password</Text>
            <View style={{ flex: 1 }} />
          </View>
          <View style={{ position: 'relative' }}>
            <TextInput
              secureTextEntry={!showPassword}
              defaultValue={password}
              style={style.inputText}
              placeholder={'Enter password'}
              onChangeText={value => setPassword(value)}
              placeholderTextColor={Colors.inputTextPlaceHolderColor}
            />
            <IconButton
              style={{ position: 'absolute', right: 0 }}
              iconColor={Colors.labelColor}
              onPress={() => setShowPassword(!showPassword)}
              icon={'eye'}
            />
          </View>
          <Button
            onPress={() => doLogin()}
            mode={'contained'}
            labelStyle={style.button}
            style={{ marginTop: 20 }}>
            Sign In
          </Button>
          {/* 🛑 Contenedor donde GSI insertará el botón de Google
            <View ref={googleButtonRef} style={style.gsiButtonContainer}  /> */}
            <View style={style.gsiButtonContainer}>

{/* Se comenta por el momento */}
            {/* <GoogleLogin
            onSuccess={handleCredentialResponse}
            onError={handleError}
          /> */}
            </View>
        </View>
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}></View>
        <Alerts />
      </View>
    </KeyboardAvoidingView>
  );
};

export default LoginScreen;

const style = StyleSheet.create({
  ...GlobalStyles,
  forgotButton: {
    color: Colors.inputTextPlaceHolderColor,
    fontStyle: 'normal',
    fontFamily: 'Sora-Regular',
    fontSize: 13,
  },
  containerWeb: {
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: .75,
    paddingRight: .75,
    maxWidth: 540,
    width: "100%"
  },
  viewWeb: {
    marginTop: 20,
    marginBottom: 10
  },
  textWeb: {
    marginTop: 10,
    marginBottom: 10
  },
  gsiButtonContainer: {
        // Estilos para centrar el botón GSI si es necesario
        marginTop: 15,
        height: 40, // Altura estándar para botones
    },
});
